import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DtpContentContainer } from 'dtp-react-components';
import { Button, DataGrid, Grid, Input } from '../../components';
import { tipoEntidade } from '../../utils/listsSelect';
import {
  buscaDestinatarios,
  doGet,
  doPost,
  doPut,
  trataMensagemSucesso,
  trataMensagensErro,
  validateObject,
} from '../../utils/requests';
import Masks from '../../utils/masks';
import ProtectedItem from '../../components/ComponentesAutenticacao/ProtectedItem';
import { obterAnoDaCompetencia, obterMesDaCompetencia, pad } from '../../utils/helpers';
// import { solicitarGlosa } from './actions';
import ModalAlerta from '../requerimentos/ModalAlerta';
import { msgsGlosaDeDacaoManual } from '../../utils/constants';

class CadastroGlosaDeDacao extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validadeCampos: {
        idDestinatario: true,
        idSolicitante: false,
        competencia: true,
        vlGlosa: false,
        observacoes: false,
        tipoGlosa: true,
        tipoAplicacao: true,
      },
      tipoEntidade: null,
      uf: null,
      glosa: {
        idDestinatario: '01000',
        idSolicitante: null,
        competencia: null,
        vlGlosa: null,
        observacoes: '',
        tipoGlosa: 1,
        tipoAplicacao: 1,
      },
      showModalAlerta: false,
      acao: props.match.params.idglosa ? 'editar' : 'novo',
      estadoFormulario: 'inicial',
      competenciaAberta: null,
    };
  }

  componentDidMount() {
    if (this.props.match.params.idglosa) {
      doGet(`glosa-manual?idGlosa=${this.props.match.params.idglosa}`, (r) => {
        this.setState({
          glosa: r.data,
        }, () => {
          const soliciante = this.props.destinatarios.filter(d => `${d.value}` === this.state.glosa.idSolicitante)[0];
          this.setState({
            tipoEntidade: soliciante.tipoRegimeProprio,
            uf: soliciante.uf,
          });
          // console.log(soliciante);
          this.buscaDadosParticipante(soliciante.value);
        });

        const glosa = { ...this.state.glosa };
        glosa.competencia = `${pad(r.data.mesPagamentoGlosa, 2)}/${r.data.anoPagamentoGlosa}`;
        glosa.vlGlosa = Number(r.data.vlGlosa).toFixed(2).toLocaleString('pt-BR', { currency: 'BRL' });

        this.setState({ glosa });
      }, this.handleErrorBusca());
      // solicitarGlosa(this.props.match.params.idglosa);
    }

    if (this.props.destinatarios.length === 0) {
      buscaDestinatarios(this.tratarErro);
    }

    this.buscaCompetenciaAbertaPagamento();
  }

  handleChange = (obj, name) => {
    const { glosa } = { ...this.state };

    this.setState({
      [name]: obj.value,
      glosa: {
        ...glosa,
        [name]: obj.value,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: obj.isValid,
      },
    });
  }

  handleChangeEntidade = (obj, name) => {
    const { glosa } = { ...this.state };
    this.setState(this.buscaDadosParticipante(obj.value));
    this.setState({
      [name]: obj.value,
      glosa: {
        ...glosa,
        [name]: obj.value,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: obj.isValid,
      },
    });
  }

  buscaDadosParticipante = (idParticipante) => {
    doGet(`participantes-compensacao/codigo/${idParticipante}`, this.buscaDadosParticipanteSuccess, this.handleErrorBusca);
  }

  buscaDadosParticipanteSuccess = (response) => {
    this.setState({
      participante: { ...this.state.participante, ...response.data },
    });
  };

  handleErrorBusca = () => {
    const mensagemPrimaria = 'Não foi possível consultar.';
    const mensagemSecundaria = 'Contate o administrador do sistema.';
    this.setState({
      mostraPaginaSemConteudo: true,
      mensagemPrincipalSemConteudo: mensagemPrimaria,
      mensagemSecundariaSemConteudo: mensagemSecundaria,
    });
  }

  buscaCompetenciaAbertaPagamento = () => {
    doGet(
      'fechamento-pagamentos/pagamento-aberto',
      (a) => {
        this.setState(prevState => ({
          ...prevState,
          competenciaAberta: `${a.data.ano}${pad(a.data.mes, 2)}`,
          glosa: {
            ...prevState.glosa,
            competencia: `${pad(a.data.mes, 2)}/${a.data.ano}`,
          },
        }));
      },
    );
  }

  handleErrorBusca = (error) => {
    let mensagemPrimaria = 'Não foi possível consultar o regime próprio.';
    let mensagemSecundaria = 'Contate o administrador do sistema.';
    if (error) {
      if (error.status) {
        if (error.status === 404) {
          mensagemPrimaria = 'Ente  Federativo não encontrado para o filtro informado.';
          mensagemSecundaria = 'Informe um filtro válido.';
        }
      }
    }
    this.setState({
      showNoContent: true,
      noContentPrimaryMessage: mensagemPrimaria,
      noContentSecondaryMessage: mensagemSecundaria,
    });
  };

  trataSucessoResponseEnvio = () => {
    if (this.state.acao === 'novo') {
      const mensagemSucesso = ['Glosa cadastrada com sucesso.'];
      trataMensagemSucesso(mensagemSucesso);
      this.props.history.push('/consultaGlosaDeDacao/consulta-glosa/');
    } else if (this.state.acao === 'editar') {
      const mensagemSucesso = ['Glosa alterada com sucesso.'];
      trataMensagemSucesso(mensagemSucesso);
      this.props.history.push('/consultaGlosaDeDacao/consulta-glosa/');
    } else {
      const mensagemErro = ['Não foi possível cadastrar a glosa.'];
      trataMensagensErro(mensagemErro);
    }
  }

  trataErrosResponse = (error) => {
    if (error && error.data) {
      const { data } = { ...error };
      this.setState({
        chaveConfirmacao: data.chaveConfirmacao,
        alertas: data.alertas,
        showModalAlerta: !this.state.showModalAlerta,
      });
    }
  }

  listaFiltradaDestinatarios = () => {
    const listaParticipantes = this.props.destinatarios.filter((item) => {
      if (item.tipoRegimeProprio === this.state.tipoEntidade &&
        ((item.uf && this.state.tipoEntidade === 2) ? item.uf === this.state.uf : true)) {
        return item;
      }
      return null;
    });
    return listaParticipantes;
  }

  carregaUfDosMunicipios = () => {
    const listaUf = [];
    this.props.destinatarios.forEach((item) => {
      if (item.uf && !listaUf.find(itemLista => itemLista.value === item.uf)) {
        listaUf.push({
          label: item.uf,
          value: item.uf,
        });
      }
    });
    listaUf.sort((a, b) => {
      if (a.value > b.value) {
        return 1;
      }
      if (a.value < b.value) {
        return -1;
      }
      return 0;
    });
    return listaUf;
  }

  montaFiltrosDefault = () => (
    <React.Fragment>
      <div className="row">
        <Grid cols="4 4 4 4">
          <Input
            label="Tipo"
            onChange={e => this.handleChange(e, 'tipoEntidade')}
            placeholder="Selecione a entidade"
            value={this.state.tipoEntidade}
            itemList={tipoEntidade}
            custom
            number
            disabled={this.state.acao !== 'novo'}
          />
        </Grid>
        {this.state.tipoEntidade === 2 ? (
          <Grid cols="4 4 4 4">
            <Input
              label="UF"
              onChange={e => this.handleChange(e, 'uf')}
              placeholder="Selecione a UF"
              value={this.state.uf}
              itemList={this.carregaUfDosMunicipios()}
              custom
              disabled={this.state.acao !== 'novo'}
            />
          </Grid>
        ) : ''}
        {this.state.tipoEntidade ? (
          <Grid cols="4 4 4 4">
            <Input
              label="Nome"
              name="destinatario-rpps"
              onChange={e => this.handleChangeEntidade(e, 'idSolicitante')}
              placeholder="Selecione o Solicitante"
              value={this.state.glosa.idSolicitante}
              itemList={this.listaFiltradaDestinatarios()}
              custom
              disabled={this.state.acao !== 'novo'}
            />
          </Grid>
        ) : ''}
      </div>
      <div className="row">
        <Grid cols="12 12 12 12">
          <Input
            disabled
            label="CNPJ"
            mask={Masks.cnpj}
            value={this.state.participante ? this.state.participante.cnpj : ''}
          />
        </Grid>
      </div>
    </React.Fragment>
  )

  formularioProntoParaEnvio = () => {
    const { acao } = { ...this.state };
    const { estadoFormulario } = { ...this.state };
    switch (acao) {
      case 'novo': {
        if (estadoFormulario === 'inicial') {
          return validateObject(this.state.validadeCampos);
        }
        return estadoFormulario === 'alterado';
      }
      case 'editar':
        return true;

      default: return false;
    }
  }

  handleSaveButton = () => {
    // FAZER AS VALIDACOES DE FRONTEND AQUI
    const mensagem = this.state.acao === 'novo' ? msgsGlosaDeDacaoManual.glosadeDacao : msgsGlosaDeDacaoManual.alterarGlosadeDacao;

    this.setState({
      alertas: [mensagem],
      showModalAlerta: !this.state.showModalAlerta,
    });
    // this.confirmSendData();
  }

  confirmSendData = () => {
    const touched = true;
    const url = 'glosa-manual';

    // Alteração para transformar o valor do campo
    // para numero antes de persistir na tabela.
    if (typeof (this.state.glosa.vlGlosa) !== 'number') {
      const vlGlosa = this.state.glosa.vlGlosa.replace(/\./g, '').replace(/,/g, '.');
      this.state.glosa.vlGlosa = Number(vlGlosa);
    }

    const { validadeCampos } = { ...this.state };
    Object.keys(validadeCampos).forEach((key) => {
      validadeCampos[key] = true;
    });

    this.setState({
      touched,
      validadeCampos,
    }, () => this.handleSave(url));
  }

  handleSave = (url) => {
    const glosaParaBackend = {
      idGlosa: this.state.acao === 'editar' ? parseInt(this.state.glosa.idGlosa, 10) : '',
      idDestinatario: '01000', // Quem dá o imóvel sempre é o INSS (RGPS)
      idSolicitante: this.state.glosa.idSolicitante,
      vlGlosa: this.state.glosa.vlGlosa,
      mesPagamentoGlosa: obterMesDaCompetencia(this.state.glosa.competencia, '/'),
      anoPagamentoGlosa: obterAnoDaCompetencia(this.state.glosa.competencia, '/'),
      tipoGlosa: 1,
      tipoAplicacao: 1,
      observacoes: this.state.glosa.observacoes,
    };

    if (this.formularioProntoParaEnvio()) {
      let options;
      if (this.state.chaveConfirmacao) {
        options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
      }

      if (this.state.acao === 'novo') {
        doPost(
          url,
          glosaParaBackend,
          this.trataSucessoResponseEnvio,
          this.trataErrosResponse,
          options,
        );
      } else {
        doPut(
          url,
          glosaParaBackend,
          this.trataSucessoResponseEnvio,
          this.trataErrosResponse,
          {
            codigo: 3009,
            mensagem: 'Esta solicitação já foi atendida por outro usuário.',
          },
          options,
        );
      }
    } else {
      trataMensagensErro(['Informe corretamente os atributos indicados na tela.']);
    }
  }

  handleFechamentoModalAlerta = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlerta: !this.state.showModalAlerta,
    });
  }

  render() {
    let modalAlerta;
    if (this.state.showModalAlerta) {
      modalAlerta = (<ModalAlerta
        alertas={this.state.alertas}
        aceitar={this.confirmSendData}
        handleModal={this.handleFechamentoModalAlerta}
        showModal
      />);
    }
    return (
      <DtpContentContainer>
        <DataGrid title="Dados do Ente Federativo" icon="ico-users">
          {this.montaFiltrosDefault()}
        </DataGrid>

        <DataGrid title="Dados da Glosa" icon="ico-money">
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                mask={Masks.competencia}
                label="Competência"
                onChange={e => this.handleChange(e, 'competencia')}
                value={this.state.glosa.competencia}
                touched
                disabled
              />
            </Grid>
            <Grid cols="8 8 8 8">
              <Input
                currency
                maxLength="16"
                label="Valor"
                onChange={e => this.handleChange(e, 'vlGlosa')}
                value={this.state.glosa.vlGlosa}
                touched={this.state.acao === 'editar' ? true : this.state.validadeCampos.vlGlosa}
              />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="12 12 12 12">
              <Input
                componentClass="textarea"
                label="Observação"
                onChange={e => this.handleChange(e, 'observacoes')}
                value={this.state.glosa.observacoes}
                touched={this.state.acao === 'editar' ? true : this.state.validadeCampos.observacoes}
                maxLength={600}
                textarea
              />
            </Grid>
          </div>
        </DataGrid>

        <ProtectedItem allowedPermissions={['gerenciar-negocio-dcomp']}>
          <Button
            className="dtp-primary right"
            disabled={!this.formularioProntoParaEnvio()}
            title="Salvar"
            onClick={() => this.handleSaveButton()}
          />
        </ProtectedItem>
        <Button
          className="left"
          onClick={this.props.history.goBack}
          title="Voltar"
          hint="Voltar para tela anterior"
        />
        {modalAlerta}
      </DtpContentContainer>
    );
  }
}

CadastroGlosaDeDacao.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      tipoConsulta: PropTypes.string,
      idglosa: PropTypes.number,
    }),
  }),
  destinatarios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  glosa: PropTypes.shape({
    idGlosa: PropTypes.number,
    idSolicitante: PropTypes.string,
    idDestinatario: PropTypes.string,
    mesPagamentoGlosa: PropTypes.number,
    anoPagamentoGlosa: PropTypes.number,
    tipoGlosa: PropTypes.number,
    tipoAplicacao: PropTypes.number,
    vlGlosa: PropTypes.number,
    observacoes: PropTypes.string,
  }),
  history: PropTypes.shape({
    goBack: PropTypes.function,
    push: PropTypes.func,
  }).isRequired,
};

CadastroGlosaDeDacao.defaultProps = {
  destinatarios: [],
  match: null,
  glosa: null,
};

const mapStateToProps = state => ({
  destinatarios: state.base.destinatarios,
  glosa: state.glosa.glosa,
});


export default connect(mapStateToProps)(CadastroGlosaDeDacao);



// WEBPACK FOOTER //
// ./src/pages/glosas/CadastroGlosaDeDacao.jsx